import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import { BidSource } from '../../../_shared/types/auction';
import ROUTES from '../../Routes/constants';
import ConfirmModal from '../../../_shared/components/ConfirmModal';
import useAnalytics, {
  getSellerProperties,
  getVinBasicProperties
} from '../../../_shared/hooks/useAnalytics';
import SegmentConfig from '../../../_shared/constants/segmentConfig';

const NegotiationErrorModalContainer = ({
  isNegotiationErrorModalOpen,
  negotiationErrorMessage,
  setIsNegotiationErrorModalOpen,
  tradeId,
  tradeDetails,
  auctionId
}) => {
  const track = useAnalytics();
  const eventSource = window.location.href.includes(ROUTES.TRADE_URI)
    ? BidSource.VDP_OVERLAY
    : BidSource.LIST_VIEW;
  const confirmModalLogic = [
    {
      msg: <FormattedMessage id={negotiationErrorMessage} />,
      title: <FormattedMessage id="list.openTrade.dgn.negotiate.error.title" />,
      confirmLabel: <FormattedMessage id="modal.ok" />,
      onConfirm: () => () => setIsNegotiationErrorModalOpen(false)
    }
  ];

  useEffect(() => {
    if (isNegotiationErrorModalOpen) {
      track(SegmentConfig.names.pendingErrorMessageShown, {
        ...getVinBasicProperties(tradeDetails),
        ...getSellerProperties(tradeDetails),
        event_state_type: tradeDetails?.isSelling
          ? SegmentConfig.eventStateType.sellPending
          : SegmentConfig.eventStateType.buyPending,
        pending_error_type: SegmentConfig.errorType.cannotNegoYet
      });

      track(MixpanelConfig.names.sellerCannotNegotiateDuplicateInDGNError, {
        source: eventSource,
        trade_id: tradeId,
        auction_id: auctionId
      });
    }
  }, [
    isNegotiationErrorModalOpen,
    auctionId,
    eventSource,
    track,
    tradeId,
    tradeDetails
  ]);

  return (
    <ConfirmModal
      modalLogic={confirmModalLogic}
      isOpen={isNegotiationErrorModalOpen}
    />
  );
};

export default NegotiationErrorModalContainer;
